import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages/PaidFeatures_messages';

const themeOptions = [
  {
    id: 1,
    color: '#eee',
    name: 'Arktinen (vaalea)',
    translation: (
      <FormattedMessage
        {...messages.brochureThemeArcticLight}
        info="Arctic light theme for the brochure"
      />
    )
  },
  {
    id: 2,
    color: '#888',
    name: 'Arktinen (tumma)',
    translation: (
      <FormattedMessage
        {...messages.brochureThemeArcticDark}
        info="Arctic dark theme for the brochure"
      />
    )
  },
  {
    id: 3,
    color: '#c56274',
    name: 'Elegantti',
    translation: (
      <FormattedMessage
        {...messages.brochureThemeElegant}
        info="Elegant theme for the brochure"
      />
    )
  },
  {
    id: 4,
    color: '#4c91b1',
    name: 'Laivaston sininen',
    translation: (
      <FormattedMessage
        {...messages.brochureThemeNavyBlue}
        info="Navy blue theme for the brochure"
      />
    )
  },
];

export default themeOptions;
